import styled from '@emotion/styled'
import { mediaMax, mediaBetween } from '@/styles/mixins'

export const Container = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2.5rem 0;
  position: relative;

  ${mediaMax.xs} {
    gap: 2rem;
    width: 100%;
    margin: 1rem 0;
  }
`

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.4rem;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fonts.sansSerif};
  text-align: left;
  white-space: nowrap;
  // position: absolute;
  // top: 50%;
  // transform: translateY(-50%);
  ${mediaMax.xs} {
    position: static;
    font-size: 1.4rem;
  }
  @media screen and (max-width: 400px) {
    font-size: 1.2rem;
  }

  @media screen and (max-width: 360px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 320px) {
    font-size: .9rem;
  }
`

export const LeftLabel = styled(Label)`
  // position: absolute;
  // left: 0;
  // top: 50%;
  // transform: translateY(-50%);
  flex-basis: 20%;

  ${mediaMax.xs} { // < 480px
    transform: none;
    // width: 22%;
  }
`

export const RightLabel = styled(Label)`
  // position: absolute;
  // right: 8%;
  // top: 50%;
  // transform: translateY(-50%) translateX(100%);
  flex-basis: 20%;
  // padding-left: 5%;
  box-sizing: border-box;

  ${mediaMax.xs} { // < 480px
    transform: none;
    // width: 35%;
  }
`

export const BarContainer = styled.div`
  // width: 75%;
  margin: 0 5% 0 0;
  overflow: hidden;
  flex: 1;

  // @media screen and (max-width: 1600px) {
  //   width: 65%;
  // }

  // ${mediaMax.xl} {
  //   width: 65%;
  // }

  // ${mediaMax.md} {
  //   width: 50%;
  // }

  // ${mediaMax.xs} {
  //   position: static;
  //   width: 43%;
  // }
`

export const BarOutter = styled.div`
  width: 100%;
  height: 7px;
  background-color: ${({ theme }) => theme.colors.lightGrey3};
  position: relative;
  ${mediaMax.xs} {
    height: 4px;
  }
`

export const BarInner = styled.div`
  position: absolute;
  left: ${({ value }) => `${(value - 1) * 10}%`};
  width: 10%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.lightGreen4};
  ${mediaMax.xs} {
    width: 20%;
    left: ${({ value }) => `${(value - 1) * 9}%`};
  }
`
